import { render, staticRenderFns } from "./DeviceViewPCInfo.vue?vue&type=template&id=32764246&scoped=true&"
import script from "./DeviceViewPCInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceViewPCInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeviceViewPCInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DeviceViewPCInfo.vue?vue&type=style&index=1&id=32764246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32764246",
  null
  
)

export default component.exports